import React from 'react';

import { Paper } from '@material-ui/core';

import { useMode } from '../../../../../../../state/ui/customerService/clientsAndLocations/index.hooks';
import { enterPreviewMode } from '../../../../../../../state/ui/customerService/clientsAndLocations';

import { useToolkitDispatch } from '../../../../../../../hooks';

import { useStyles } from '../../../../../Themable.hooks';

import ClientAndLocationPreview from '../ClientAndLocationPreview';
import ClientAddForm from '../ClientAddForm';
import ClientEditForm from '../ClientEditForm';
import LocationEditForm from '../LocationEditForm';
import LocationAddForm from '../LocationAddForm';

const ClientAndLocationPane = () => {
    const classes = useStyles();

    const mode = useMode();
    const toolkitDispatch = useToolkitDispatch();
    const handleClose = () => {
        toolkitDispatch(enterPreviewMode());
    };

    const renderPane = () => {
        switch (mode) {
            case 'create':
                return <ClientAddForm />;
            case 'preview':
                return <ClientAndLocationPreview />;
            case 'editClient':
                return <ClientEditForm handleClose={handleClose} />;
            case 'editLocation':
                return <LocationEditForm handleClose={handleClose} />;
            case 'addLocation':
                return <LocationAddForm handleClose={handleClose} />;
            default:
                return;
        }
    };

    return (
        <Paper className={classes.formPane}>
            <div className={classes.wrapper}>{renderPane()}</div>
        </Paper>
    );
};

export default ClientAndLocationPane;
